import React, { useContext, useEffect, useState } from 'react';
import { Container, Table, Button, Row, Col, Input, Modal, ModalHeader, ModalBody, ModalFooter, Form, FormGroup, Label } from 'reactstrap';
import PaginationMaterial from "../../components/PaginationMaterial/PaginationMaterial";
import LoadingSpinner from '../../components/LoadingSpinner/LoadingSpinner';
import Header from '../../components/Headers/Header';
import AdminNavbar from '../../components/Navbars/AdminNavbar/AdminNavbar';
import { AuthContext } from '../../context/AuthContext';
import useUser, { UserType, CreateEmpresaUserType, EditEmpresaUserType } from '../../context/hooks/useUser';
import { createPermissionChecker, PermissionModule } from '../../types/permissions';
import { UserTypeContext } from '../../context/UserTypeContext';

const UsuariosEmpresa = () => {
    const { objUserTk } = useContext(AuthContext);
    const { createEmpresaUser, getUsersPaged, updateEmpresaUser, deleteEmpresaUser, listUsers, pageCount, userPermissions, getPermissionsByUser, useLegacyPermissions, modulePermissions } = useUser();
    const hasPermission = createPermissionChecker(useLegacyPermissions, userPermissions, modulePermissions);
    const { getAllUserTypePaged, listUserType } = useContext(UserTypeContext);
    const [loaging, setLoading] = useState(true);
    const [newEmpresaUser, setNewEmpresaUser] = useState<CreateEmpresaUserType>({
        name: '', email: '', password: '', idUserType: 0, idEmpresa: objUserTk.EmpresaId
    });
    const [editingEmpresaUser, setEditingEmpresaUser] = useState<EditEmpresaUserType | null>(null);
    const [dataSearch, setDataSearch] = useState({ name: '' });
    const [createModalOpen, setCreateModalOpen] = useState(false);
    const [editModalOpen, setEditModalOpen] = useState(false);

    useEffect(() => {
        setLoading(true);

        // handleGetInstituicaoByEmpresaId(objUserTk.Id);

        getAllUserTypePaged(1, 50, objUserTk.EmpresaId);

        getUsersPaged(1, "", objUserTk.EmpresaId, 9)
            .then(data => {
                setLoading(false);
            })
            .catch(error => {
                console.error("Erro ao buscar usuários:", error);
                setLoading(false);
            });
    }, []);

    useEffect(() => {
        const fetchPermissions = async () => {
            if (objUserTk?.UserId) {
                const permissions = await getPermissionsByUser(objUserTk.UserId);
            }
        };

        fetchPermissions().catch(error => console.error("Erro ao carregar permissões:", error));
    }, [objUserTk?.UserId]);

    const onChangePaginationCommon = async (e: any, value: any) => {
        await getUsersPaged(value, dataSearch.name, objUserTk.EmpresaId, 9);
    };

    const handleSearchChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setDataSearch({ ...dataSearch, name: e.target.value });
    };

    const handleSearchSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        setLoading(true);
        getUsersPaged(1, dataSearch.name, objUserTk.EmpresaId, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleSearchButtonClick = () => {
        setLoading(true);
        getUsersPaged(1, dataSearch.name, objUserTk.EmpresaId, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };

    const handleClearFilters = () => {
        setDataSearch({ name: '' });
        setLoading(true);
        getUsersPaged(1, "", objUserTk.EmpresaId, 9)
            .then(() => setLoading(false))
            .catch(() => setLoading(false));
    };


    const handleCreateInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;
        if (type === 'checkbox') {
            setNewEmpresaUser(prevAluno => ({
                ...prevAluno,
                [name]: checked,
            }));
        } else {
            setNewEmpresaUser(prevAluno => ({
                ...prevAluno,
                [name]: value,
            }));
        }
    };

    const handleCreateEmpresaUser = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        createEmpresaUser(newEmpresaUser)
            .then(createdEmpresaAluno => {
                if (createdEmpresaAluno) {
                    setCreateModalOpen(false);
                    setNewEmpresaUser({
                        name: '', email: '', password: '', idUserType: 0, idEmpresa: objUserTk.EmpresaId
                    });
                    getUsersPaged(1, "", objUserTk.EmpresaId, 9);
                } else {
                    console.error("Erro ao criar usuáio.");
                }
            })
            .catch(error => {
                console.error("Erro ao criar usuário:", error);
            });
    };

    const handleEditInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name, value, type, checked } = e.target;;
        setEditingEmpresaUser(prevAluno => ({
            ...prevAluno!,
            [name]: type === 'checkbox' ? checked : value,
        }));
    }

    const handleEditEmpresaUser = (empresauser: UserType) => {
        const updateData: EditEmpresaUserType = {
            id: empresauser.id,
            name: empresauser.name,
            email: empresauser.email,
            password: "",
            idUserType: empresauser.idUserType,
            agencia: empresauser.empresa?.agencia || "",
            contaBeneficiario: empresauser.empresa?.contaBeneficiario || "",
        };
        setEditingEmpresaUser(updateData);
        setEditModalOpen(true);
    };

    const handleEditSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (editingEmpresaUser) {
            updateEmpresaUser(editingEmpresaUser)
                .then(updatedEmpresaUser => {
                    if (updatedEmpresaUser) {
                        setEditModalOpen(false);
                        getUsersPaged(1, "", objUserTk.EmpresaId, 9);
                    } else {
                        console.error("Erro ao atualizar usuário.");
                    }
                })
                .catch(error => {
                    console.error("Erro ao atualizar usuário:", error);
                });
        }
    };

    const handleDeleteEmpresaUser = (userId: number) => {
        if (window.confirm("Tem certeza que deseja excluir este usuário?")) {
            deleteEmpresaUser(userId)
                .then(() => {
                    console.log("usuário excluído com sucesso");
                    setTimeout(() => {
                        getUsersPaged(1, "", objUserTk.EmpresaId, 9);
                    }, 500);
                })
                .catch(error => {
                    console.error("Erro ao excluir usuário:", error);
                });
        }
    };

    return (
        <>
            <LoadingSpinner />
            <Header />
            <AdminNavbar
                brandText={"Gerenciar usuários"}
                search={false}
                titleSearch={""}
            />

            <Container className="mt-5">
                <Row className="align-items-center mb-4">
                    <Col xs="12" md="9" lg="9" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="text"
                            name="search"
                            id="search"
                            placeholder="Buscar por nome"
                            value={dataSearch.name}
                            onChange={handleSearchChange}
                        />
                    </Col>
                    {/* <Col xs="12" md="4" lg="4" className="mb-2">
                        <Input
                            className="form-control-alternative"
                            type="select"
                            name="instituicaoId"
                            value={dataSearch.instituicaoId}
                            onChange={(e) => setDataSearch({ ...dataSearch, instituicaoId: parseInt(e.target.value) || 0 })}
                        >
                            <option value="0">Todas as instituições</option>
                            {listInstituicao.map((instituicao) => (
                                <option key={instituicao.id} value={instituicao.id}>
                                    {instituicao.name}
                                </option>
                            ))}
                        </Input>
                    </Col> */}
                    <Col xs="12" md="3" lg="3" className="d-flex justify-content-start justify-content-md-end mb-2">
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#585858" }}
                            type="button"
                            size="m"
                            onClick={handleSearchButtonClick}
                            className="mr-2"
                        >
                            Buscar
                        </Button>
                        <Button
                            style={{ color: "#FFF", backgroundColor: "#d9534f" }}
                            type="button"
                            size="m"
                            onClick={handleClearFilters}
                        >
                            Limpar
                        </Button>
                    </Col>
                    {hasPermission(PermissionModule.GestaoUsuarios, 1) && (
                        <Col xs="12" className="text-right mt-3">
                            <Button
                                style={{ color: "#FFF", backgroundColor: "#585858" }}
                                size="m"
                                onClick={() => setCreateModalOpen(true)}
                            >
                                Adicionar usuário
                            </Button>
                        </Col>
                    )}
                </Row>

                {hasPermission(PermissionModule.GestaoUsuarios, 2) ? (
                    <Row className="mt-4">
                        <Col>
                            <Table hover responsive className="table-striped">
                                <thead>
                                    <tr>
                                        <th>Nome</th>
                                        <th>Email</th>
                                        <th>Editar</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {listUsers.map((users: UserType, index: number) => (
                                        <tr key={index}>
                                            <td>{users.name}</td>
                                            <td>{users.email}</td>
                                            <td>
                                                {hasPermission(PermissionModule.GestaoUsuarios, 3) && (
                                                    <Button onClick={() => handleEditEmpresaUser(users)}><i className="fa-solid fa-pen-to-square"></i></Button>
                                                )}
                                                {hasPermission(PermissionModule.GestaoUsuarios, 4) && (
                                                    <Button onClick={() => handleDeleteEmpresaUser(users.id)} color="danger"><i className="fa-solid fa-trash"></i></Button>
                                                )}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </Table>
                            <div className="d-flex justify-content-end mt-3">
                                {pageCount && (
                                    <div className="d-flex justify-content-center mt-4">
                                        <PaginationMaterial
                                            onChange={(e: any, value: any) => onChangePaginationCommon(e, value)}
                                            count={pageCount}
                                        />
                                    </div>
                                )}
                                {listUsers.length === 0 && (
                                    <div style={{ color: "red" }}>NÃO FOI ENCONTRADO NENHUM REGISTRO</div>
                                )}
                            </div>
                        </Col>
                    </Row>
                ) : (
                    <Row className="mt-4">
                        <Col>
                            <div style={{ color: "red", textAlign: "center" }}>
                                Você não tem permissão para visualizar os usuários da empresa.
                            </div>
                        </Col>
                    </Row>
                )}
            </Container>

            <Modal isOpen={createModalOpen} toggle={() => {
                setCreateModalOpen(!createModalOpen);
                setNewEmpresaUser({
                    name: '', email: '', password: '', idUserType: 0, idEmpresa: objUserTk.EmpresaId
                });
            }} backdrop="static" size="lg">
                <ModalHeader toggle={() => setCreateModalOpen(!createModalOpen)}>Adicionar novo usuário</ModalHeader>
                <ModalBody>
                    <Form onSubmit={handleCreateEmpresaUser}>
                        {/* <Row>
                            <Col md="12">
                                <FormGroup>
                                    <Label className="form-control-label">Instituição</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        name="InstituicaoId"
                                        value={newAluno.instituicaoId}
                                        onChange={handleCreateInputChange}
                                        required
                                    >
                                        <option value="">Selecione uma instituição</option>
                                        {listInstituicao.map((instituicao) => (
                                            <option key={instituicao.id} value={instituicao.id}>
                                                {instituicao.name}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row> */}
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="name">Nome</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="name"
                                        id="name"
                                        value={newEmpresaUser.name}
                                        placeholder="Nome"
                                        onChange={handleCreateInputChange}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label">Tipo de usuário</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="select"
                                        name="idUserType"
                                        value={newEmpresaUser.idUserType}
                                        onChange={handleCreateInputChange}
                                        required
                                    >
                                        <option value="">Selecione um tipo de usuário</option>
                                        {listUserType.map((userType) => (
                                            <option key={userType.id} value={userType.id}>
                                                {userType.type}
                                            </option>
                                        ))}
                                    </Input>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="email">Email</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="email"
                                        name="email"
                                        id="email"
                                        value={newEmpresaUser.email}
                                        placeholder="Email"
                                        onChange={handleCreateInputChange}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <Label className="form-control-label" htmlFor="password">Senha</Label>
                                    <Input
                                        className="form-control-alternative"
                                        type="text"
                                        name="password"
                                        id="password"
                                        value={newEmpresaUser.password}
                                        placeholder="Senha"
                                        onChange={handleCreateInputChange}
                                        required
                                    />
                                </FormGroup>
                            </Col>
                        </Row>
                        <div className="d-flex justify-content-end mt-4">
                            <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Criar usuário</Button>
                            <Button style={{ color: "#FFF", backgroundColor: "#d9534f" }} className="ml-2" onClick={() => {
                                setCreateModalOpen(false);
                                setNewEmpresaUser({
                                    name: '', email: '', password: '', idUserType: 0, idEmpresa: objUserTk.EmpresaId
                                });
                            }} size="m">Cancelar</Button>
                        </div>
                    </Form>
                </ModalBody>
            </Modal>

            <Modal isOpen={editModalOpen} toggle={() => setEditModalOpen(!editModalOpen)} backdrop="static" size="lg">
                <ModalHeader toggle={() => setEditModalOpen(!editModalOpen)}>Alterar informações do usuário</ModalHeader>
                <ModalBody>
                    {editingEmpresaUser && (
                        <Form onSubmit={handleEditSubmit}>
                            <Row>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="name">Nome</Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="text"
                                            name="name"
                                            id="name"
                                            value={editingEmpresaUser?.name || ''}
                                            placeholder="Nome"
                                            onChange={handleEditInputChange}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                                <Col md="6">
                                    <FormGroup>
                                        <Label className="form-control-label">Tipo de usuário</Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="select"
                                            name="idUserType"
                                            value={editingEmpresaUser?.idUserType ?? ''}
                                            onChange={handleEditInputChange}
                                            required
                                        >
                                            <option value="">Selecione um tipo de usuário</option>
                                            {listUserType.map((userType) => (
                                                <option key={userType.id} value={userType.id}>
                                                    {userType.type}
                                                </option>
                                            ))}
                                        </Input>
                                    </FormGroup>
                                </Col>
                            </Row>
                            <Row>
                                <Col md="12">
                                    <FormGroup>
                                        <Label className="form-control-label" htmlFor="email">Email</Label>
                                        <Input
                                            className="form-control-alternative"
                                            type="email"
                                            name="email"
                                            id="email"
                                            value={editingEmpresaUser?.email || ''}
                                            placeholder="Email"
                                            onChange={handleEditInputChange}
                                            required
                                        />
                                    </FormGroup>
                                </Col>
                            </Row>
                            <div className="d-flex justify-content-end">
                                <Button style={{ color: "#FFF", backgroundColor: "#585858" }} type="submit" size="m">Salvar alterações</Button>
                                <Button style={{ color: "#FFF", backgroundColor: "#d9534f" }} className="ml-2" onClick={() => {
                                    setEditModalOpen(false);
                                }} size="m">Cancelar</Button>
                            </div>
                        </Form>
                    )}
                </ModalBody>
            </Modal>
        </>
    );
};

export default UsuariosEmpresa;